import { Vue, Component, Watch } from "vue-property-decorator";
import QuantityButton from "@/components/quantityButton/quantityButton";
import { Action, Getter, Mutation } from "vuex-class";
import { localCurrency } from "@/plugins/currency";
import { tagsArrayToString, tagsStringToArray } from "@/plugins/subscriptions_helper";
import Loading from "@/components/loading/loading";
import PaymentMethodPicker from "@/components/paymentMethodPicker/paymentMethodPicker";
import Payment from "@/components/payment/payment";
import ModalCreditCard from "@/components/modalCreditCard/modalCreditCard";
import ModalAddress from "@/components/modalAddressHome/modalAddress";
import Multiselect from "@/components/multiselect/multiselect";
import MultiselectDays from "@/components/multiselectdays/multiselectdays.vue";
import StepsCounter from "@/components/stepsCounter/stepsCounter";
import moment from "moment";
import MealsCarousel from "@/components/mealsCarousel/mealsCarousel.vue";
import ModalCreditCardNew from "@/components/modalCreditCardNew/modalCreditCard.vue";

@Component({
  components: {
    QuantityButton,
    Loading,
    PaymentMethodPicker,
    Payment,
    ModalCreditCard,
    ModalAddress,
    Multiselect,
    StepsCounter,
    MealsCarousel,
    MultiselectDays,
    ModalCreditCardNew
  },
  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm) => {
      if(!vm.getIsToken) {
        next("/mi-menu/comenzar");
      }
      else if (
        vm.getSubscription && (vm.isSubscriptionActive == false)
      ) {
        next("/mi-menu/mi-dashboard");
      } else {
        next();
      }
    });
  }
})
export default class SubscriptionsSettings extends Vue {
  // Actions
  @Action action_getMenus;
  @Action action_createSubscription;
  @Action action_updateSubscription;
  @Action action_getAllSubscriptions;
  @Action action_getTags;
  @Action action_applyDiscountCode;

  // Getters
  @Getter getMenus;
  @Getter getCity;
  @Getter getIncludeProteins;
  @Getter getFoodRestrictions;
  @Getter getSubscriptionTemporal;
  @Getter getIsToken;
  @Getter getUser;
  @Getter getCurrentPaymentMethod;
  @Getter getCurrentAddress;
  @Getter getAllSubscriptions;
  @Getter getSubscription;
  @Getter getCurrentOrder;
  @Getter getCurrentCityZone;
  @Getter getOpenIngredientsModal;
  @Getter getTags;

  // Mutations
  @Mutation PATH_TEMPORAL;
  @Mutation SUBSCRIPTION_TEMPORAL;
  @Mutation CURRENT_PAYMENT_METHOD;
  @Mutation CURRENT_ADDRESS;
  @Mutation TAGS;
  @Mutation CURRENT_CITY_ZONE;
  @Mutation SET_INGREDIENT_TO_DESTROY;

  currentStep = 1;
  isLoading = false;
  openModal = false;
  openTagsModal = false;
  openEditModal = false;
  openIngredientModal = false;
  openPaymentModal = false;
  showModalDiscount = false;
  availableDays = [];
  tags: any;
  tagsSelected = []

  paymentType1 = false;
  paymentType2 = false;
  paymentType3 = false;

  // Cupon 
  coupon = {
    id: null,
    code: ""
  };

  inputValue = "";

  // Carousel
  innerStyles = {};
  step = 400; // Steps for the carousel

  
  user = {};
  showCreditCardModal = false;
  showAddressModal = false;
  payment = {
    card: null,
    type: "",
    value: null
  };
  

  subscriptionsForm = {
    user_id: "",
    name: "",
    creation_week_day: 1,
    address_id: "",
    program_schedule: "",
    preferences: "",
    no_include: "",
    comments: "sin comentarios",
    status: "pending",
    details: [],
    person_quantity: 1,
    current_step: 1,
    payment_way: null,
    credit_card_id: null,
    delivery_day: null
  };

  menuDetails = [];
  includeProteins = [];
  foodRestrictions = [];
  agregate = [];
  avoid = [];
  delivery = ["Lunes", "Martes", "Miercoles" , "Jueves", "Viernes" ]
  days = []
  deliveryDays = [
    {
      name: "Lunes",
      value: 1
    },
    // {
    //   name: "Martes",
    //   value: 2
    // },
    // {
    //   name: "Miércoles",
    //   value: 3
    // },
    // {
    //   name: "Jueves",
    //   value: 4
    // },
    {
      name: "Viernes",
      value: 5
    },
    {
      name: "Sábado",
      value: 6
    }
  ];
  programSchedules = [];
  communicationTypes = [
    {
      name: "Whatsapp",
      value: "contact_whatsapp"
    },
    {
      name: "Llamada telefónica",
      value: "contact_telephone"
    },
    {
      name: "No contactarme",
      value: "contact_none"
    }
  ];
  selectedCommunicationType = {
    name: "",
    value: ""
  };

  selectedDeliveryDay = {
    name: "",
    value: -1
  };

  currentAddress = null;
  currentCityZone = null;
  errors = [];

  steps = [
    { value: 1, label: "Revisar menú" },
    { value: 2, label: "Envío y pago." },
    { value: 3, label: "Comenzar" }
  ];

  get isCouponApplied() {
    return this.getSubscription.subscription_discount &&
    this.getSubscription.subscription_discount.code;
  }

  get getSteps() {
    let response = [
      { value: 1, label: "Revisar menú" },
      { value: 2, label: "Envío y pago" },
      { value: 3, label: "Comenzar" }
    ];
    // if (this.getSubscription) {
    //   response[2].label = "Pago y Entrega";
    // }
    return response;
  }

  get getRawTotal() {
    let response = 0;
    if (this.menuDetails && this.menuDetails.length) {
      this.menuDetails.forEach((menu) => {
        if (this.getMenus && this.getMenus.length && menu.menu_id && menu.count) {
          const findIndex = this.getMenus.findIndex((item) => item.id === menu.menu_id);
          if (
            findIndex !== -1 &&
            this.getMenus[findIndex].prices &&
            this.getMenus[findIndex].prices.length &&
            this.getMenus[findIndex].prices[menu.count]
          ) {
            const price = this.getMenus[findIndex].prices[menu.count];
            response += menu.count * price;
          }
        }
      });
    }
    response *= this.subscriptionsForm.person_quantity;
    return response;
  }

  get getCurrentTotal() {
    let response = 0;
    if (this.menuDetails && this.menuDetails.length) {
      this.menuDetails.forEach((menu) => {
        if (this.getMenus && this.getMenus.length && menu.menu_id && menu.count) {
          const findIndex = this.getMenus.findIndex((item) => item.id === menu.menu_id);
          if (
            findIndex !== -1 &&
            this.getMenus[findIndex].prices &&
            this.getMenus[findIndex].prices.length &&
            this.getMenus[findIndex].prices[menu.count]
          ) {
            const price = this.getMenus[findIndex].prices[menu.count];
            response += menu.count * price;
          }
        }
      });
    }
    response *= this.subscriptionsForm.person_quantity;
    return localCurrency(response);
  }

  get getPreferences() {
    let response = [];
    if(this.getSubscription && this.getSubscription.preferences) {
      response = tagsStringToArray(this.getSubscription.preferences);
    }
    return response;
  }

  get getNotIncluded() {
    let response = [];
    if(this.getSubscription && this.getSubscription.no_include) {
      response = tagsStringToArray(this.getSubscription.no_include);
    }
    return response;
  }

  get getSubscriptionDetails() {
    // Return subscription details if they have more than one item
    return this.getSubscription.details_subscription_menus.filter((item) => item.count > 0);
  }


  get getDeliveryDay() {
    let response = "";
    if(this.getSubscription.deal_date) {
      response = moment(this.getSubscription.deal_date).format("ddd DD-MMM");
    }
    return response;
  }

  get getProgramSchedule() {
    let response = "";
    if(this.getSubscription && this.getSubscription.program_schedule) {
      response = this.getSubscription.program_schedule;
    }
    return response;
  }

  get isSubscriptionActive() {
    let response = false;
    if (this.getSubscription && this.getSubscription.status) {
      response =
        this.getSubscription.status === "active" || this.getSubscription.status === "pending";
    }
    return response;
  }

  get AggregateTags() {
    return this.tags.filter((item) => item.type_tag === "aggregate");
  }

  get AvoidTags() {
    return this.tags.filter((item) => item.type_tag === "avoid");
  }

  _toggleDiscount() {
      this.showModalDiscount = !this.showModalDiscount;
  }

  getProgramSchedules() {
    let response = [];
    if (
      this.currentCityZone &&
      this.currentCityZone.delivery_schedule &&
      this.currentCityZone.delivery_schedule.hour_range
    ) {
      this.currentCityZone.delivery_schedule.hour_range.forEach((item) => {
        // TODO: Formatear hora para que sea más legible
        let copy = item.replace(/ /g, "");
        const arr = copy.split(",");
        const time1 = moment(arr[0], "H:mm");
        const time2 = moment(arr[1], "H:mm");
        copy = `${time1.format("hh:mm A")} - ${time2.format("hh:mm A")}`;
        response.push(copy);
      });
    }
    this.programSchedules = response;
  }

  _login() {
    const name = this.$route.name
    const query = this.$route.query
    const params = this.$route.params
    this.PATH_TEMPORAL({ name, params, query })
    this.$router.push({ name: 'login' });
  }

  getPreferencesMessage(type: string) {
    let response = "";
    let count = 0;
    if (type === "preferences") {
      if (this.includeProteins && this.includeProteins.length) {
        this.includeProteins.forEach((preference) => {
          if (preference.selected) {
            count++;
          }
        });
      }
      response = `${count} de ${this.includeProteins.length}`;
    } else if (type === "restrictions") {
      if (this.foodRestrictions && this.foodRestrictions.length) {
        this.foodRestrictions.forEach((restriction) => {
          if (restriction.selected) {
            count++;
          }
        });
      }
      response = `${count} de ${this.foodRestrictions.length}`;
    }
    return response;
  }

  get missingForFreeDelivery() {
    let response = 0;
    if (this.getCity && this.getCity.free_delivery_amount) {
      const minimumValue = parseInt(this.getCity.free_delivery_amount);
      if (this.getRawTotal < minimumValue) {
        response = minimumValue - this.getRawTotal;
      }
    }
    return response;
  }

  get deliveryCost() {
    let response = 0;
    if (this.getCity && this.getCity.variables && this.missingForFreeDelivery !== 0) {
      response = 5900;
    }
    return response;
  }

  get isPaymentWay() {
    let response = true;
    if (
      !this.getSubscriptionTemporal.payment_way ||
      !this.getSubscriptionTemporal.payment_way.length
    ) {
      response = false;
    } else if (
      this.getSubscriptionTemporal.payment_way === "credit_card" &&
      !this.getSubscriptionTemporal.credit_card_id
    ) {
      response = false;
    }
    return response;
  }

  get showPaymentMethods() {
    let response = false;
    if (this.currentStep === 3 && this.getIsToken && this.getSubscription) {
      response = true;
    }
    return response;
  }

  get isCurrentOrderActive() {
    let response = false;
    if (this.getCurrentOrder && !this.getIsTerminalStatus && !this.getIsFinished) {
      response = true;
    }
    return response;
  }

  get getIsTerminalStatus() {
    let response = false;
    if (this.getCurrentOrder && this.getCurrentOrder.status) {
      const status = this.getCurrentOrder.status;
      response =
        status === "troubleshooting_restaurant" ||
        status === "order_not_generated" ||
        status === "order_canceled_by_restaurant" ||
        status === "order_canceled_in_handoff" ||
        status === "troubleshooting_hand_off";
    }
    return response;
  }

  get getIsFinished() {
    let response = false;
    if (this.getCurrentOrder && this.getCurrentOrder.status) {
      const status = this.getCurrentOrder.status;
      response = status === "order_completed";
    }
    return response;
  }

  get isBeforeDeadline() {
    let response = true;
    if(this.getSubscription && this.getSubscription.deadline_update_date) {
      const today = moment(new Date());
      const deadline = moment(this.getSubscription.deadline_update_date);
      response = today.isBefore(deadline);
    }
    return response;
  }

  getTime() {
    let actualDate = new Date();
    let hours = actualDate.getHours();
    return hours
  }

 

  formatHourRange(value) {
    let hour1 = value.split(",")[0].trim();
    let hour2 = value.split(",")[1].trim();
    hour1 = moment(hour1, "HH:mm");
    hour2 = moment(hour2, "HH:mm");
    return hour1.format("hh:mm A") + " - " + hour2.format("hh:mm A");
  }

  setAvailableWeekDays() {
    let daysAvailables = [1, 2, 3, 4, 5, 6];
    const deliverySchedule = this.getCurrentCityZone.delivery_schedule;
    if (this.getCurrentCityZone && deliverySchedule) {
      const tempWeekdays = deliverySchedule.weekdays ? deliverySchedule.weekdays : [];
      if(tempWeekdays.length) {
        tempWeekdays.forEach((item) => {
          daysAvailables.push(parseInt(item));
        });
        daysAvailables = [...tempWeekdays];
      }
    }
    let startDay = moment(new Date());
    let nextDay = startDay.clone();
    if(this.getTime() < 15) {
      nextDay.add(1, "days");
    }
    else {
      nextDay.add(3, "days");
    }
    
    let endDay = startDay.clone();
    if(this.getTime() < 15) {
      endDay.add(5, "days");
    }
    else {
      endDay.add(6, "days");
    }
    
    let dayOfWeek = -1;
    while (nextDay.isSameOrBefore(endDay)) {
      dayOfWeek = nextDay.day();
      let found = false;
      for(let i = 0; i < daysAvailables.length && !found; i++) {
        if(dayOfWeek == daysAvailables[i]) {
          found = true;
        }
      }
      if (found) {
        const nextDayClone = nextDay.clone();
        nextDayClone.set('hour', 0);
        nextDayClone.set('minute', 0);
        nextDayClone.set('second', 0);
        this.availableDays.push(nextDayClone);
      } else {
        endDay.add(1, "days");
      }
      nextDay.add(1, "days");
    }
  }

  async _tags() {
    this.tags = await this.action_getTags();
    return this.tags
  }

  addTags(tag) {
    // Check if the tag is already in the list
    let found = false;
    this.tagsSelected.forEach((item) => {
      if (item === tag) {
        found = true;
      }
    });
      
    // If not, add it to the list
    if (!found) {
      this.tagsSelected.push(tag);
    }
    // Else remove it from the list
    else {
      this.tagsSelected.splice(this.tagsSelected.indexOf(tag), 1);
    }
  }

  // Check if the tag is already selected
  isTagSelected(tag) {
    let response = false;
    this.tagsSelected.forEach((item) => {
      if (item == tag.id) {
        response = true;
      }
    });
    return response;
  }

  async mounted() {
    this.SET_INGREDIENT_TO_DESTROY(null);
    this._tags()
    if (!this.isBeforeDeadline) {
      this.$swal({
        title: "Orden activa",
        text: `Podrás configurar tu siguiente semana luego de recibir tu pedido.`
      });
      this.$router.replace({ name: "subscriptions_settingsNew" });
    } else {
      this.isLoading = true;
      this.menuDetails = [];
      try {
        if (this.getIsToken && this.getCity && this.getCity.id) {
          await this.action_getAllSubscriptions({
            commerceId: this.getCity.id
          });
          if (this.getSubscription && this.getSubscription.id) {
            this.SUBSCRIPTION_TEMPORAL({ ...this.getSubscription, current_step: 1 });
          }
        }
      } catch (error) {
        this._showErrorMessage(error);
      }
      await this._getSubscriptionsInfo();
      this._fillUserSubscription();
      this.isLoading = false;
    }
    this.onCurrentAddressChange();
    this.setAvailableWeekDays()
  }

  

  @Watch("getCurrentAddress")
  onCurrentAddressChange() {
    
    this.currentAddress = { ...this.getCurrentAddress };
    if (this.currentAddress && this.currentAddress.zone_id) {
      this.currentCityZone = this.getCityZoneById(this.currentAddress.zone_id);
      this.CURRENT_CITY_ZONE(this.currentCityZone);
      this.getProgramSchedules();
    } else {
      this.currentCityZone = null;
      this.programSchedules = [];
      this.selectedDeliveryDay = {
        name: "",
        value: -1
      };
    }
  }

  @Watch("getIsToken")
  onLogout() {
    if (!this.getIsToken) {
      this.subscriptionsForm = {
        user_id: "",
        name: "",
        creation_week_day: 1,
        address_id: "",
        program_schedule: "11:00 AM - 03:30 PM",
        preferences: "",
        no_include: "",
        comments: "",
        status: "pending",
        details: [],
        person_quantity: 1,
        current_step: 1,
        payment_way: null,
        credit_card_id: null,
        delivery_day: null
      };
    }
    this.menuDetails = [];
    this.currentAddress = null;
    this.currentCityZone = null;
    this.errors = [];
    this.includeProteins = [];
    this.foodRestrictions = [];
    
    this.selectedCommunicationType = {
      name: "",
      value: ""
    };
    this.selectedDeliveryDay = {
      name: "",
      value: -1
    };
    this.SUBSCRIPTION_TEMPORAL(null);
  }

  async _getSubscriptionsInfo() {
    try {
      // Se recorren los menús de la ciudad y a partir de ahí se crea el menú detail
      if (this.getCity && this.getCity.id) {
        await this.action_getMenus({ commerceId: this.getCity.id });
        if (this.getMenus && this.getMenus.length) {
          this.getMenus.forEach((menu) => {
            if (menu.id) {
              this.menuDetails.push({
                menu_id: menu.id,
                count: 0
              });
            }
          });
        }
      }
      // Se crean los tags de proteínas incluidas
      if (this.getIncludeProteins && this.getIncludeProteins.length) {
        this.includeProteins = this.getIncludeProteins.map((protein) => {
          return { value: protein, selected: false };
        });
      }
      // Se crean los tags de las restricciones
      if (this.getFoodRestrictions && this.getFoodRestrictions.length) {
        this.foodRestrictions = this.getFoodRestrictions.map((restriction) => {
          return { value: restriction, selected: false };
        });
      }
    } catch (error) {
      this._showErrorMessage(error);
    }
  }

  async deactivateSubscription() {
    this.isLoading = true;
    try {
      if (this.getCity && this.getCity.id && this.getSubscription && this.getSubscription.id) {
        const payload = {
          commerceId: this.getCity.id,
          subscriptionId: this.getSubscription.id,
          subscription: {
            subscription: {
              status: "inactive"
            }
          }
        };
        let alert = await this.$swal({
          title: "Desactivar suscripción",
          text: "¿Estás seguro de que deseas desactivar tu suscripción? Te vamos a extrañar",
          showCancelButton: true,
          confirmButtonText: "Aceptar"
        });
        if (alert.value) {
          await this.action_updateSubscription(payload);
          this.$router.replace({ name: "subscriptions_settingsNew" });
        }
      }
    } catch (error) {
      this._showErrorMessage(error);
    }
    this.isLoading = false;
  }

  _fillUserSubscription() {
    if (this.getSubscriptionTemporal) {
      // Se copia el subscription temporal en el formulario
      this.subscriptionsForm = { ...this.getSubscriptionTemporal };

      if (this.getSubscriptionTemporal.current_step) {
        this.currentStep = this.subscriptionsForm.current_step;
      } else {
        this.currentStep = 1;
      }

      // Se recorren las preferncias guardadas y se marcan como seleccionadas las que aparezcan
      if (this.subscriptionsForm.preferences && this.subscriptionsForm.preferences.length) {
        const preferencesArray = tagsStringToArray(this.subscriptionsForm.preferences);
        preferencesArray.forEach((preference) => {
          const findIndex = this.includeProteins.findIndex((protein) => protein.value === preference);
          if (findIndex !== -1) {
            this.includeProteins[findIndex].selected = true;
          }
        });
      }

      // Se recorren las restricciones guardadas y se marcan como seleccionadas las que aparezcan
      if (this.subscriptionsForm.no_include && this.subscriptionsForm.no_include.length) {
        const restrictionsArray = tagsStringToArray(this.subscriptionsForm.no_include);
        restrictionsArray.forEach((restriction) => {
          const findIndex = this.foodRestrictions.findIndex((food) => food.value === restriction);
          if (findIndex !== -1) {
            this.foodRestrictions[findIndex].selected = true;
          }
        });
      }

      // Se guarda el valor del día de entrega
      if (this.subscriptionsForm.creation_week_day) {
        const findIndex = this.deliveryDays.findIndex(
          (deliveryDay) => deliveryDay.value === this.subscriptionsForm.creation_week_day
        );
        if (findIndex !== -1) {
          this.selectedDeliveryDay = this.deliveryDays[findIndex];
        }
      }

      // Se buscan los menus que ya tiene guardados el usuario y se les asigna su valor
      if (this.getSubscriptionTemporal && this.getSubscriptionTemporal.details) {
        this.getSubscriptionTemporal.details.forEach((detail) => {
          if (detail.menu_id && detail.count >= 0) {
            const findIndex = this.menuDetails.findIndex((item) => item.menu_id === detail.menu_id);
            if (findIndex !== -1) {
              this.menuDetails[findIndex].count = detail.count;
            }
          }
        });
      }
      // Se asigna el valor guardado de cantidad de personas
      if (this.getSubscriptionTemporal && this.getSubscriptionTemporal.person_quantity) {
        this.subscriptionsForm.person_quantity = this.getSubscriptionTemporal.person_quantity;
      }

      // Se busca la dirección que viene guardada y se guarda en el atributo
      if (this.subscriptionsForm.address_id) {
        const address = this.getAddressById(this.subscriptionsForm.address_id);
        this.currentAddress = { ...address };
        this.CURRENT_ADDRESS({ ...address });
      } else {
        this.CURRENT_ADDRESS(null);
      }

      if (this.subscriptionsForm.comments && this.subscriptionsForm.comments.length) {
        const findIndex = this.communicationTypes.findIndex(
          (comm) => comm.value == this.subscriptionsForm.comments
        );
        if (findIndex !== -1) {
          this.selectedCommunicationType = this.communicationTypes[findIndex];
        } else {
          this.selectedCommunicationType = this.communicationTypes[0];
        }
      }

      // Se busca y setea el método de pago
      if (this.subscriptionsForm.payment_way) {
        if (
          this.subscriptionsForm.payment_way === "credit_card" &&
          this.subscriptionsForm.credit_card_id
        ) {
          const card = this.getCreditCardById(this.subscriptionsForm.credit_card_id);
          if (card) {
            this.payment = {
              card: card,
              type: "credit_card",
              value: card.credit_card_number
            };
          } else {
            this.payment = {
              card: null,
              type: "",
              value: null
            };
            this.subscriptionsForm.payment_way = null;
            this.subscriptionsForm.credit_card_id = null;
          }
        } else if (this.subscriptionsForm.payment_way === "cash") {
          this.payment = {
            card: null,
            type: "cash",
            value: "default"
          };
          this.subscriptionsForm.credit_card_id = null;
        }
      } else {
        this.payment = {
          card: null,
          type: "",
          value: null
        };
        this.subscriptionsForm.credit_card_id = null;
      }
    } else {
      this.currentStep = 1;
    }
    if (this.getIsToken && this.getUser) {
      this.user = { ...this.getUser };
      this.subscriptionsForm.user_id = this.getUser.id;
    } else {
      this.user = null;
      this.subscriptionsForm.user_id = "";
    }
    if (!this.currentAddress) {
      this.CURRENT_ADDRESS(null);
    }
  }

  

  getCreditCardById(cardId) {
    let response = null;
    if (this.getUser && this.getUser.credit_cards) {
      response = this.getUser.credit_cards.find((card) => card.id == cardId);
    }
    return response;
  }

  getAddressById(addressId) {
    let response = null;
    if (this.getUser && this.getUser.addresses && this.getUser.addresses.length) {
      response = this.getUser.addresses.find((address) => address.id == addressId);
    }
    return response;
  }

  getMenuPricePerDish(menuId) {
    let response = "";
    const findIndex = this.getMenus.findIndex((menu) => menuId === menu.id);
    const findIndex2 = this.menuDetails.findIndex((menu) => menuId === menu.menu_id);
    if (findIndex !== -1 && findIndex2 !== -1) {
      const menu = this.getMenus[findIndex];
      const menuDetail = this.menuDetails[findIndex2];
      if (
        menuDetail.count >= 0 &&
        menu.prices &&
        menu.prices.length &&
        menu.prices[menuDetail.count]
      ) {
        response = `${localCurrency(menu.prices[menuDetail.count])} c/u`;
      }
    }
    return response;
  }

  _changeMenuQuantity(value, menuId) {
    const findIndex = this.menuDetails.findIndex((menu) => menuId === menu.menu_id);
    if (findIndex !== -1) {
      this.menuDetails[findIndex].count = value;
    }
    this.saveTempForm();
  }

  _WaLink(phone) {
    return "https://wa.me/" + phone
  }

  _getMenuQuantity(menuId) {
    let response = 0;
    const findIndex = this.menuDetails.findIndex((menu) => menuId === menu.menu_id);
    if (findIndex !== -1) {
      response = this.menuDetails[findIndex].count;
    }
    return response;
  }

  _changePersonQuantity(value) {
    this.subscriptionsForm.person_quantity = value;
    this.saveTempForm();
  }

  _toggleProtein(value) {
    if (value && value.length) {
      const findIndex = this.includeProteins.findIndex((protein) => protein.value === value);
      if (findIndex !== -1) {
        const isSelected = this.includeProteins[findIndex].selected;
        this.includeProteins[findIndex].selected = !isSelected;
      }
    }
    this.saveTempForm();
  }

  _toggleRestriction(value) {
    if (value && value.length) {
      const findIndex = this.foodRestrictions.findIndex((restriction) => restriction.value === value);
      if (findIndex !== -1) {
        const isSelected = this.foodRestrictions[findIndex].selected;
        this.foodRestrictions[findIndex].selected = !isSelected;
      }
    }
    this.saveTempForm();
  }

  _showErrorMessage(error) {
    let msg = "";
    if (error && error.response && error.response.data && error.response.data.message) {
      msg = error.response.data.message;
    }
    this.$swal({
      title: "Error",
      text: "¡Ups! Hubo un error procesando la solicitud. " + msg
    });
  }

  _saveDataBeforeLogin() {
    this.saveTempForm();
    this._redirectToLogin(null);
  }

  saveTempForm() {
    const preferencesArray = this._toTagsArray(this.includeProteins);
    const restrictionsArray = this._toTagsArray(this.foodRestrictions);
    this.subscriptionsForm.preferences = tagsArrayToString(preferencesArray);
    this.subscriptionsForm.no_include = tagsArrayToString(restrictionsArray);
    this.subscriptionsForm.details = [...this.menuDetails];
    this.subscriptionsForm.current_step = this.currentStep;
    this.subscriptionsForm.comments = this.selectedCommunicationType.value;
    this.subscriptionsForm.creation_week_day = this.selectedDeliveryDay.value;
    if (this.currentAddress && this.currentAddress.id) {
      this.subscriptionsForm.address_id = this.currentAddress.id;
    }
    if (this.getUser && this.getUser.id) {
      this.subscriptionsForm.user_id = this.getUser.id;
    }
    if (this.payment && this.payment.type && this.payment.type.length) {
      let paymentWay = null;
      let cardId = null;
      if (this.payment.type === "credit_card" && this.payment.card && this.payment.card.id) {
        paymentWay = "credit_card";
        cardId = this.payment.card.id;
      } else if (this.payment.type === "cash") {
        paymentWay = "cash";
      }
      this.subscriptionsForm.payment_way = paymentWay;
      this.subscriptionsForm.credit_card_id = cardId;
    }
    this.SUBSCRIPTION_TEMPORAL(this.subscriptionsForm);
  }

  _toTagsArray(array) {
    let response = [];
    if (array && array.length) {
      array.forEach((item) => {
        if (item.selected && item.value) {
          response.push(item.value);
        }
      });
    }
    return response;
  }

  openCollapsible(id: any) {
    let content = document.getElementsByClassName('collapsible-content-'+id)[0]  as HTMLElement;

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
      content.style.marginTop = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
      content.style.marginTop = 0.6 + 'rem'
    }


  }

  openPaymentCollapsible(id: any) {
    let content = document.getElementsByClassName('collapsible-content-'+id)[0]  as HTMLElement;

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
      content.style.marginTop = null;
      content.style.padding = null;
    } else {
      content.style.maxHeight = '500px';
      content.style.marginTop = 0.6 + 'rem'
      content.style.padding = '12px 16px'
    }


  }

  _addPlate() {
    this.$router.push('/mi-menu/platos')
  }

  _addIngredient() {
    this.$router.push('/mi-menu/ingredients')
  }

  _redirectToLogin(option: string) {
    const name = this.$route.name;
    const query = this.$route.query;
    const params = this.$route.params;
    params["modal"] = option;

    this.PATH_TEMPORAL({ name, params, query });
    this.$router.push({ name: "login" });
  }

  _onGoHome() {
    if(this.getSubscription) {
      this.$router.replace({ name: 'subscriptions_settingsNew' });
    }
  }

  goToStep1() {
    this.currentStep = 1;
  }
  goToStep2() {
      this.currentStep = 2;
  }
  goToStep3() {
      this.currentStep = 3;
    
  }

  _onNextStep() {
    this._validate();
    this.isLoading = true;
    setTimeout(() => {
      switch (this.currentStep) {
        case 1:
          this.currentStep = 2;
          // if (!this.isError("empty_quantity")) {
          //   this.currentStep = 2;
          //   this.saveTempForm();
          // } else {
          //   this.$swal({
          //     title: "Advertencia",
          //     text: "Agrega al menos un plato antes de continuar"
          //   });
          // }
          break;
        case 2:
          if (!this.isError("no_preferences")) {
            this.currentStep = 3;
            this.saveTempForm();
          } else {
            this.$swal({
              title: "Advertencia",
              text: "Agrega al menos una preferencia antes de continuar"
            });
          }
          break;
        case 3:
          break;
      }
      document.getElementById("subscriptionBody").scroll({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
      this.isLoading = false;
    }, 500);
  }

  _onPreviousStep() {
    this.isLoading = true;
    setTimeout(() => {
      switch (this.currentStep) {
        case 3:
          this.currentStep = 2;
          this.saveTempForm();
          break;
        case 2:
          this.currentStep = 1;
          this.saveTempForm();
          break;
        case 1:
          this.saveTempForm();
          this.$router.replace({ name: "subscriptions_settingsNew" });
          break;
      }
      this.isLoading = false;
    }, 500);
  }

  _onSetStep(value) {
  

    if (this.getSubscription && this.currentStep !== value && !this.isLoading) {
      this._validate();
      this.isLoading = true;
      setTimeout(() => {
        this.currentStep = value;
        this.saveTempForm();
        document.getElementById("subscriptionBody").scroll({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
        this.isLoading = false;
      }, 500);
    }
  }

  isError(value: string) {
    let response = false;
    const findIndex = this.errors.findIndex((error) => error === value);
    if (findIndex !== -1) {
      response = true;
    }
    return response;
  }

  _toggleModalCreditCard() {
    this.showCreditCardModal = !this.showCreditCardModal;
  }

  _toggleModalAddress() {
    this.showAddressModal = !this.showAddressModal;
    this.onCurrentAddressChange();
  }

  _setProgramSchedule(value) {
    this.subscriptionsForm.program_schedule = value;
  }

  _onSetCommunicationType(value) {
    this.selectedCommunicationType = { ...value };
  }

  _setPaymentMethod(value) {
    this.payment = { ...value };
  }

  _validate() {
    this.errors = [];

    if (!this.getRawTotal) {
      this.errors.push("empty_quantity");
    }
    let noProteins = true;

    this.includeProteins.forEach((item) => (item.selected ? (noProteins = false) : false));
    if (noProteins) {
      this.errors.push("no_preferences");
    }

    if (!this.currentAddress || !this.currentAddress.address) {
      this.errors.push("no_address");
    }

    if (this.selectedDeliveryDay.value === -1) {
      this.errors.push("no_delivery_day");
    }

    if (!this.subscriptionsForm.program_schedule.length) {
      this.errors.push("no_schedule");
    }
  }

  _money(value) {
    let response = "";
    try {
      response = localCurrency(value);
    } catch (error) {
      this._showErrorMessage(error);
    }
    return response;
  }

  getMenuById(menuId) {
    let response = null;
    if(this.getMenus && this.getMenus.length) {
      response = this.getMenus.find((menu) => menu.id === menuId);
    }
    return response;
  }

  tagToString(value: string) {
    return value.replace(/_/g, ' ');
  }

  async updateModal() {
    if (this.getCity && this.getCity.id) {
      let payload = {
        commerceId: this.getCity.id,
        subscriptionId: -1,
        subscription: {
          subscription: { ...this.subscriptionsForm }
        }
      };
      if (this.getSubscription && this.getSubscription.id) {
        payload.subscriptionId = this.getSubscription.id;
        await this.action_updateSubscription(payload);
      }
    }
  }

  async _updateSubscriptionForm() {
    if(this.subscriptionsForm.details != []) {
      if (this.getCity && this.getCity.id) {
        this.saveTempForm();
        let payload = {
          commerceId: this.getCity.id,
          subscriptionId: -1,
          subscription: {
            subscription: { ...this.subscriptionsForm , tags: this.tagsSelected }
          }
        };
        if (this.getSubscription && this.getSubscription.id) {
          payload.subscriptionId = this.getSubscription.id;
          await this.action_updateSubscription(payload);
        }
      }
    }
    this.openModal = false;
    this.openTagsModal = false;
    this.openEditModal = false;
    this.openIngredientModal = false;
    this.openPaymentModal = false;
  }

  async _updateSubscription() {
    this.subscriptionsForm.status == "Active"
    if (this.getCity && this.getCity.id) {
      this.saveTempForm();
      let payload = {
        commerceId: this.getCity.id,
        subscriptionId: -1,
        subscription: {
          subscription: { ...this.subscriptionsForm , tags: this.tagsSelected }
        }
      };
      if (this.getSubscription && this.getSubscription.id) {
        payload.subscriptionId = this.getSubscription.id;
        await this.action_updateSubscription(payload);
      } else {
        await this.action_createSubscription(payload);
      }
    }
    this.$router.push('/mi-menu/mi-dashboard')
  }

  async _submitSubscription() {
    this.isLoading = true;

    if (this.getIsToken) {
      this._validate();
      if (this.errors.length === 0) {
        try {
          if (this.getCity && this.getCity.id) {
            this.saveTempForm();
            let payload = {
              commerceId: this.getCity.id,
              subscriptionId: -1,
              subscription: {
                subscription: { ...this.subscriptionsForm }
              }
            };
            if (this.getSubscription && this.getSubscription.id) {
              payload.subscriptionId = this.getSubscription.id;
              await this.action_updateSubscription(payload);
              this.$router.replace({ name: "subscriptions_settingsNew" });
            }
            this.SUBSCRIPTION_TEMPORAL(null);
          }
        } catch (error) {
          this._showErrorMessage(error);
        }
      } else {
        let msg = "";
        if (this.isError("no_address")) {
          msg += "Debes agregar una dirección para continuar. ";
        }
        if (this.isError("empty_quantity")) {
          msg += "Debes seleccionar al menos un tipo de plato. ";
        }
        if (this.isError("no_preferences")) {
          msg += "Debes seleccionar al menos una preferencia. ";
        }
        if (this.isError("no_delivery_day")) {
          msg += "Selecciona un día de entrega. ";
        }
        if (this.isError("no_schedule")) {
          msg += "Selecciona un horario de entrega. ";
        }
        if (this.isError("no_name")) {
          msg += "Ponle un nombre a tu suscripción";
        }
        this.$swal({
          title: "Advertencia",
          text: msg
        });
      }
    } else {
      this.$swal({
        title: "Error",
        text: "Debes iniciar sesión para crear tu suscripción"
      });
    }
    this.isLoading = false;
  }

  private getCityZoneById(zoneId) {
    let res = null;
    if (this.getCity && this.getCity.zones) {
      for (let i = 0; i < this.getCity.zones.length && !res; i++) {
        if (this.getCity.zones[i].id === zoneId) {
          res = this.getCity.zones[i];
        }
      }
    }
    return res;
  }

  setStep () {
    this.step = 40;
  }

  @Watch('getSubscription', { deep: true })
  _setInitialDiscount() {
    if (
      this.getSubscription &&
      this.getSubscription.subscription_discount &&
      this.getSubscription.subscription_discount.id &&
      this.getSubscription.subscription_discount.code
    ) {
      this.coupon = {
        id: this.getSubscription.subscription_discount.id,
        code: this.getSubscription.subscription_discount.code
      };
      this.inputValue = this.getSubscription.subscription_discount.code;
    } else {
      this.coupon = {
        id: null,
        code: ""
      };
      this.inputValue = "";
    }
  }

  async _applyCoupon() {
    if (this.inputValue !== "") {
      this.isLoading = true;
      try {
        let payload = null;
        let close = false;
        payload = {
          commerceId: this.getCity.id,
          subscriptionId: this.getSubscription.id
        };
        if (
          this.getSubscription.subscription_discount &&
          this.getSubscription.subscription_discount.code
        ) {
          payload.code = {
            code: ""
          };
          this.inputValue = "";
        } else {
          payload.code = {
            code: this.inputValue
          };
          close = true;
        }
        await this.action_applyDiscountCode(payload);
      } catch (error) {
        let msg = "";
        if (error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message;
        }
        this.$swal({
          title: "Error",
          text: `¡Ups! Hubo un error enviando la solicitud. ${msg}`
        });
      }
      this.isLoading = false;
    } 
  }

  _onPlateAdded(items) {
    console.log('Hello from Index', items);
  }

  _onOpenIngredientsModal(item) {
    this.openIngredientModal = true;
    console.log('Opne',this.$store.state.mealIngredients)
  }

  _onOpenTagsModal() {

    this.getSubscription.tags_aggregate.forEach((tag) => {
      if(!this.tagsSelected.includes(tag.id)) {
        this.tagsSelected.push(tag.id);
      }
    });

    this.getSubscription.tags_avoid.forEach((tag) => {
      if(!this.tagsSelected.includes(tag.id)) {
        this.tagsSelected.push(tag.id);
      }
    });
    
    this.openTagsModal = true;
  }
  
  onSelectedDeliveryDay(value) {
    this.subscriptionsForm.delivery_day = value;
  }

  
}
